import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';

interface StaffCommissionProps {
  onSaveCommission: (driverCommission: number, motorBoyCommission: number) => void;
  initialDriverCommission: number;
  initialMotorBoyCommission: number;
}

const CommissionSettings = ({
  onSaveCommission,
  initialDriverCommission,
  initialMotorBoyCommission
}: StaffCommissionProps) => {
  const [driverCommission, setDriverCommission] = useState<number>(initialDriverCommission);
  const [motorBoyCommission, setMotorBoyCommission] = useState<number>(initialMotorBoyCommission);
  const [loading, setLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    setDriverCommission(initialDriverCommission);
    setMotorBoyCommission(initialMotorBoyCommission);
  }, [initialDriverCommission, initialMotorBoyCommission]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSaveCommission(driverCommission, motorBoyCommission);
      setIsEditable(false);
    } finally {
      setLoading(false);
    }
  };

  const toggleEditMode = () => {
    setIsEditable(prev => !prev);
  };

  return (
    <Card className="py-4 px-4" style={{ boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
      <Row className="mt-2">
        <Col xs={12}>
          <div className="form-group">
            <Form.Label className="mb-1">Driver Commission (%)</Form.Label>
            <Form.Text>Percentage of each item's value paid to the driver. Cans count at a quarter.</Form.Text>
            <Form.Control
              type="number"
              min={0}
              max={100}
              step="any"
              placeholder="Enter driver commission (%)"
              value={driverCommission}
              onChange={e => setDriverCommission(Number(e.target.value))}
              readOnly={!isEditable}
            />
          </div>
        </Col>

        <Row className="mt-2">
          <Col xs={12}>
            <div className="form-group">
              <Form.Label className="mb-1">Motorboy Commission (%)</Form.Label>
              <Form.Text>Percentage of each item's value paid to the motorboy. Cans count at a quarter.</Form.Text>
              <Form.Control
                type="number"
                min={0}
                max={100}
                step="any"
                placeholder="Enter motorboy commission (%)"
                value={motorBoyCommission}
                onChange={e => setMotorBoyCommission(Number(e.target.value))}
                readOnly={!isEditable}
              />
            </div>
          </Col>
          <Row>
            <Col>
              <Button
                size="sm"
                onClick={isEditable ? handleSave : toggleEditMode}
                disabled={loading}
                style={{ minWidth: '80px' }}
              >
                {loading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span className="ms-2">Saving</span>
                  </>
                ) : isEditable ? (
                  'Save'
                ) : (
                  'Edit'
                )}
              </Button>
            </Col>
          </Row>
        </Row>
      </Row>
    </Card>
  );
};

export default CommissionSettings;
